import type { BMSSensoreDto } from '../../dto/bms/bms-sensore-dto'
import type { BmsSensor } from '../../types/bms/bms-sensor'

const mapToBMSSensor = (dto: BMSSensoreDto): BmsSensor => {
    return {
        id: dto.id,
        name : dto.nome ?? undefined,
        deviceLocation : dto.deviceLocation ?? undefined,
        deviceDescription : dto.deviceDescription ?? undefined,
        attribute : dto.attribute ?? undefined,
        measureUnit : dto.measureUnit ?? undefined,
        idRoom : dto.idRoom ?? undefined
    }
}

const mapToBMSSensoreDto = (sensor: BmsSensor): BMSSensoreDto => {
    return {
        id: sensor.id,
        nome: sensor.name ?? null,
        deviceLocation: sensor.deviceLocation ?? null,
        deviceDescription: sensor.deviceDescription ?? null,
        attribute: sensor.attribute ?? null,
        measureUnit: sensor.measureUnit ?? null,
        idRoom: sensor.idRoom ?? null,
    }
}

export { mapToBMSSensor, mapToBMSSensoreDto }
